var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6325 24.2546L36.6555 18.9933V16.8803C36.6555 16.5907 36.5196 16.3179 36.2884 16.1435L22.5556 5.78766C22.2265 5.53953 21.7732 5.53953 21.4441 5.78766L7.71138 16.1435C7.48012 16.3179 7.34419 16.5907 7.34419 16.8803V18.9933L0.36719 24.2546C0.135933 24.429 0 24.7018 0 24.9915V34.3159C0 34.8256 0.413204 35.2388 0.922918 35.2388H8.26711H15.6113H28.3884H35.7326H43.0768C43.5865 35.2388 43.9997 34.8256 43.9997 34.3159V24.9915C43.9997 24.7018 43.8638 24.429 43.6325 24.2546ZM22.9978 33.3928H21.0018V28.7405H22.9978V33.3928ZM24.8436 33.3928V27.8176C24.8436 27.3079 24.4304 26.8947 23.9207 26.8947H20.0789C19.5692 26.8947 19.156 27.3079 19.156 27.8176V33.3928H14.6882H9.19003V17.3402L21.9999 7.6803L34.8097 17.3402V33.3928H29.3114H24.8436ZM1.84584 25.4514L7.34419 21.3051V33.3928H1.84584V25.4514ZM42.1539 33.3928H36.6555V21.3051L42.1539 25.4514V33.3928Z",
    fill: "#11294B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.47862 18.3193L22 2.8445L42.5212 18.3195C42.6877 18.445 42.8827 18.5056 43.0763 18.5056C43.3559 18.5056 43.6324 18.3789 43.8138 18.1383C44.1207 17.7314 44.0397 17.1526 43.6326 16.8458L22.5557 0.951725C22.2266 0.703592 21.7733 0.703592 21.4442 0.951725L0.36729 16.8457C-0.0397175 17.1526 -0.120803 17.7313 0.186134 18.1382C0.492938 18.5452 1.07187 18.6263 1.47862 18.3193Z",
    fill: "#11294B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousing);
export default __webpack_public_path__ + "static/media/housing.01f9537c70f8d3250eba9e39c658de2c.svg";
export { ForwardRef as ReactComponent };